import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions_Wind from '~/Actions_Wind';
import permission from '~/skills/permission';
import * as getStatus from '~/skills/getStatus';
import {
  Select,
  MenuItem,
  TableRow,
  TableCell,
  TableHead,
  TableContainer,
  TableBody,
  Table,
} from '@material-ui/core';
import { ArrowBackIos, ArrowForwardIos, FirstPage, LastPage } from '@mui/icons-material';
import { T_TitleCell, T_Btn_Function, T_TableRow } from '~/components/TableItem';
import T_common from '~/components/TableItem/common';
import CheckDelete from '~/components/Dialog/CheckDelete';
import PageTitle from '~/components/PageTitle';
import AddAndEdit from './AddAndEdit';

class Page_AdminProgram extends Component {
  state={
    // keyword: '',

    per_page: 10,
    page: 1,

    sort: true,
    sort_field: 'upd_time',
    view_checkDelete: false,
    view_addAndEdit: false,
    mode_addAndEdit: '',
    currentId: '',
    currentAct: '',
  }

  componentDidMount () {
    // const { status, keyword, org_id } = this.state;
    // this.data = { status, keyword, org_id };
    this.refresh();

    const queryParams = new URLSearchParams(this.props.location.search);
    const adminProgramId = queryParams.get('id');
    const assignedWindcontractId = queryParams.get('contractId');

    if (adminProgramId || assignedWindcontractId) {
      localStorage.setItem('Wind_ID', assignedWindcontractId);
      this.setState({ currentId: adminProgramId, view_addAndEdit: true, mode_addAndEdit: 'edit' });
    }
  }

  componentWillUnmount () {
    this.props.clearKey('AProList');
  }

  refresh=() => {
    const { page, per_page, sort, sort_field } = this.state;
    // const { status, keyword, org_id } = this.data;
    this.props.getAProList({
      page,
      per_page,
      body: {
        sort: sort ? 'desc' : 'asc',
        sort_field,
      },
    });
  }

  search=() => this.setState({ page: 1 }, () => this.refresh());

  _click_search=() => {
    // const { status, keyword, org_id, sort, sort_field } = this.state;
    // this.data = { status, keyword, org_id, sort, sort_field };
    this.search();
  }

  _delete=(id, act) => this.setState({ currentId: id, currentAct: act, view_checkDelete: true })
  _close_view_checkDelete=() => {
    // this.refresh();
    this.setState({ currentId: '', currentAct: '', view_checkDelete: false });
  }

  _add=() => this.setState({ view_addAndEdit: true, mode_addAndEdit: 'add' })
  _view=id => this.setState({ currentId: id, view_addAndEdit: true, mode_addAndEdit: 'view' })
  _edit=id => this.setState({ currentId: id, view_addAndEdit: true, mode_addAndEdit: 'edit' })
  _close_view_addAndEdit=() => {
    this.refresh();
    this.setState({ currentId: '', view_addAndEdit: false, mode_addAndEdit: '' });
  }

  renderTableTitle=() => {
    const { sort, sort_field } = this.state;
    const onChangeSort = t => {
      this.setState({ sort_field: t, sort: sort_field === t ? !sort : false }, () => this.search());
    };
    const ary = [
      { name: '序號' },
      { name: '程序文件', id: 'proc_type' },
      { name: '預訂申請時間', id: 'reserve_apply_time' },
      { name: '預定完成時間', id: 'reserve_get_time' },
      { name: '實際申請時間', id: 'actual_apply_time' },
      { name: '實際達成時間', id: 'actual_get_time' },
      { name: '表單狀態', id: 'form_status' },
      { name: '申請狀態', id: 'apply_status' },
      { name: '功能' },
    ];
    return (
      <TableHead>
        <TableRow style={{ height: 48 }}>
          {ary.map((o, i) => (
            <T_TitleCell
              key={i}
              text={o.name}
              arrow={!!o.id}
              bol={sort_field === o.id ? sort : true}
              onClick={() => onChangeSort(o.id)}
            />
          ))}
        </TableRow>
      </TableHead>
    );
  }

  renderTableBody=() => {
    const { AProList = {}, canEdit, sign: { role_level = 1 } = {} } = this.props;
    const { list = [], page = 0, total = 0, per_page = 0 } = AProList;
    const cellStyle = { fontSize: 14 };
    const checkCanEdit = (form_status, admin_status) => {
      const formStatus = Number(form_status);
      const adminStatus = Number(admin_status);
      const roleLevel = Number(role_level);
    
      if (!canEdit) return false;
    
      switch (roleLevel) {
        case 1:
          return formStatus < 2;
    
        case 2:
          return formStatus >= 2 && formStatus < 3;
    
        case 3:
          return formStatus === 3 && adminStatus === 1;
    
        default:
          return false;
      }
    };

    let start = 0;
    if (page > 0) {
      start = (page - 1) * per_page + 1;
      if (start > total)start = 0;
    }
    return (
      <TableBody>
        {list.map((o, i) => (
          <T_TableRow key={i} backgroundColor= {i % 2 === 0 ? '#E0FDFF' : 'white'}>
            <TableCell align='center' style={cellStyle}>{i + start}</TableCell>
            <TableCell align='left' style={cellStyle}>{o.proc_type}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.reserve_apply_time}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.reserve_get_time}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.actual_apply_time}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.actual_get_time}</TableCell>
            <TableCell align='center' style={cellStyle}>{getStatus.form(o)}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.apply_status}</TableCell>
            <TableCell>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                <T_Btn_Function text='檢視' backgroundColor={T_common.type1} onClick={() => this._view(o.id)} />
                {
                  checkCanEdit(o.form_status, o.admin_status) &&
                  <T_Btn_Function text='編輯' backgroundColor={T_common.type2} onClick={() => this._edit(o.id)} style={{ marginLeft: 8 }} disabled={!checkCanEdit(o.form_status, o.admin_status)} />
                }
                {
                  !checkCanEdit(o.form_status, o.admin_status) && <div style={{ marginLeft: 5, marginRight: 5 }}></div>
                }
                {/* <T_Btn_Function text='刪除' backgroundColor={T_common.type3} onClick={() => this._delete(o.id, o.account)} /> */}
              </div>
            </TableCell>
          </T_TableRow>
        ))}
      </TableBody>
    );
  }

  renderTableBar=() => {
    const { AProList = {} } = this.props;
    const { has_next = false, has_prev = false, page = 0, pages = 0, total = 0 } = AProList;
    const { per_page, page: statePage } = this.state;
    const returnPages = () => {
      const array = [];
      for (let i = 1; i <= pages; i++) {
        array.push(i);
      }
      return array;
    };
    const returnPers = () => [10, 20, 30, 40];
    const canFirst = page > 1;
    const canLast = page < pages;
    return (
      <div style={{ height: 48, display: 'flex', alignItems: 'center', width: '98%', backgroundColor: 'white', borderBottomRightRadius: 8, borderBottomLeftRadius: 8, paddingTop: 6, paddingBottom: 6 }}>
        <div style={{ flex: 1 }} />
        <FirstPage style={{ height: 24, width: 24, color: canFirst ? 'black' : 'gray', cursor: canFirst ? 'pointer' : 'default' }} onClick={() => { if (canFirst) this.setState({ page: 1 }, () => this.refresh()); }} />
        <ArrowBackIos style={{ marginLeft: 3, marginRight: 5, height: 16, width: 16, color: has_prev ? 'black' : 'gray', cursor: has_prev ? 'pointer' : 'default' }} onClick={() => { if (has_prev) this.setState({ page: this.state.page - 1 }, () => this.refresh()); }} />
        <div style={{ fontSize: 14 }}>第</div>
        <Select
          style={{ backgroundColor: 'white', height: 36, fontSize: 16, letterSpacing: '0.15px', marginRight: 8, marginLeft: 8 }}
          variant="outlined"
          value={statePage}
          onChange={e => this.setState({ page: e.target.value }, () => { this.refresh(); })}
        >
          {returnPages().map((o, i) => <MenuItem key={i} value={o}>{o}</MenuItem>)}
        </Select>
        <div style={{ fontSize: 14, marginRight: 8 }}>{`/${pages} 頁，每頁`}</div>
        <Select
          style={{ backgroundColor: 'white', height: 36, fontSize: 16, letterSpacing: '0.15px' }}
          variant="outlined"
          value={per_page}
          onChange={e => this.setState({ per_page: e.target.value }, () => { this.search(); })}
        >
          {returnPers().map((o, i) => <MenuItem key={i} value={o}>{o}</MenuItem>)}
        </Select>
        <div style={{ fontSize: 14, marginLeft: 8 }}>{`筆，共${total}筆`}</div>
        <ArrowForwardIos style={{ marginLeft: 5, height: 16, width: 16, color: has_next ? 'black' : 'gray', cursor: has_next ? 'pointer' : 'default' }} onClick={() => { if (has_next) this.setState({ page: this.state.page + 1 }, () => this.refresh()); }} />
        <LastPage style={{ marginRight: 19, height: 24, width: 24, color: canLast ? 'black' : 'gray', cursor: canLast ? 'pointer' : 'default' }} onClick={() => { if (canLast) this.setState({ page: pages }, () => this.refresh()); }} />
        <div style={{ flex: 1 }} />
      </div>
    );
  }

  renderTable=() => {
    const { AProList = {} } = this.props;
    const { list = [] } = AProList;
    const haveData = list.length > 0;
    return (
      <TableContainer style={{ marginTop: 18, maxWidth: '98%' }}>
        <Table style={{ backgroundColor: 'white', borderTopLeftRadius: 8, borderTopRightRadius: 8 }}>
          {this.renderTableTitle()}
          {haveData && this.renderTableBody()}
        </Table>
      </TableContainer>
    );
  }

  renderMainPage=() => {
    const { deleteUser, AProList = {} } = this.props;
    const { currentId, view_checkDelete, currentAct } = this.state;
    const { list = [] } = AProList;
    const haveData = list.length > 0;
    return (
      <div style={{
        position: 'absolute',
        left: 13,
        right: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        overflow: 'auto',
      }}
      >
        <PageTitle text='行政程序' />
        {this.renderTable()}
        {haveData && this.renderTableBar()}
        {!haveData && <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 30 }}>尚無資料</div>}
        <CheckDelete
          open={view_checkDelete}
          text={`帳號：${currentAct}`}
          onClose={this._close_view_checkDelete}
          search={this.search}
          resKey='DeleteUser'
          onDelete={() => { deleteUser(currentId); }}
        />
      </div>
    );
  }

  render () {
    const { currentId, view_addAndEdit, mode_addAndEdit } = this.state;
    return !view_addAndEdit
      ? this.renderMainPage()
      : <AddAndEdit id={currentId} mode={mode_addAndEdit} _onClose={this._close_view_addAndEdit} />;
  }
}
const mapStateToProps = state => ({
  sign: state.data.AtyFunction,
  AProList: state.data.AProList,
  ...permission.returnPermission(state),
});
const mapDispatchToProps = dispatch => ({
  getAProList: body => Actions_Wind.getAProList(dispatch, body),
  clearKey: key => Actions_Wind.clearKey(dispatch, { key }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Page_AdminProgram);
